import type { DeepUnwrap } from '../../../index'

/** Workflow plugins that can store type-specific data for a record. */
export const WORKFLOW_PLUGIN_TYPES = ['sharepoint'] as const

/**
 * Discriminates workflow plugin settings and record data.
 *
 * These values must stay aligned with the database's
 * `workflow_plugin_type_enum`.
 */
export type WorkflowPluginType = (typeof WORKFLOW_PLUGIN_TYPES)[number]

/**
 * Defines one plugin's persisted workflow-record data.
 *
 * Add the plugin discriminator to {@link WORKFLOW_PLUGIN_TYPES}, define its data
 * with this utility, and include the resulting type in
 * `WorkflowPluginDataType`.
 *
 * @example
 * export type MyAppPluginData = SetupPluginData<{
 *   type: 'my_app'
 *   externalId: string
 * }>
 */
export type SetupPluginData<T extends { type: WorkflowPluginType }> =
  DeepUnwrap<T>
